const TRUSTED_HOSTS = [
  'localhost:8081', // Your confirmation server
  'gateway.zscalertwo.net',
  'gateway.zscalerone.net',
];

export const handleRedirect = (response: Response) => {
  if (!response.redirected || !response.url) {
    return;
  }

  const redirectUrl = new URL(response.url);

  if (!TRUSTED_HOSTS.includes(redirectUrl.host)) {
    return;
  }

  window.location.href = redirectUrl.href;
};
